<template>
  <div class="plan-row-item-neon-title">
    <template v-if="isFundamentalsAnnual">
      <div class="plan-row-item-neon-title__name">{{ this.plan.name }}</div>
      <div class="plan-row-item-neon-title__type">SUBSCRIPTION</div>
    </template>
    <template v-if="isLeapYearBundle">
      <div class="plan-row-item-neon-title__name">Premium</div>
      <div class="plan-row-item-neon-title__type">SUBSCRIPTION</div>
      <div class="plan-row-item-neon-title__type plan-row-item-neon-title__type--plus">+</div>
      <div class="plan-row-item-neon-title__type">1 INE SECURITY</div>
      <div class="plan-row-item-neon-title__name">Certification</div>
    </template>
  </div>
</template>

<script>
import CONSTANTS from '@/constants'

const {
  PLANS: { ANNUAL },
  LEAP_YEAR_PROMO_PRODUCT_BUNDLES: { INE_LEAP_YEAR_BUNDLE },
} = CONSTANTS

export default {
  name: 'PlanRowItemPrice',
  props: {
    plan: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isFundamentalsAnnual() {
      return this.plan.merchant_id === ANNUAL
    },
    isLeapYearBundle() {
      return this.plan.merchant_id === INE_LEAP_YEAR_BUNDLE
    },
  },
}
</script>

<style lang="scss" scoped>
.plan-row-item-neon-title {
  height: 200px;
  padding-bottom: 30px;
  margin: 30px 0;
  border-bottom: 1px solid var(--mid-gray-translucid);
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  position: relative;
  @include mobile {
    padding-bottom: 40px;
    margin: 70px 0 40px 0;
  }
  @include desktop {
    padding-bottom: 40px;
    margin: 40px 0;
  }
  &__name {
    color: var(--white);
    font-size: rem(24px);
    font-style: normal;
    font-weight: 700;
    line-height: rem(32px);
    word-spacing: 200px;
    text-align: center;
    text-transform: capitalize;
    @include desktop {
      word-spacing: unset;
      width: 50%;
    }
  }
  &__type {
    color: var(--purple-pale);
    font-size: rem(12px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(14px);
    &--plus {
      font-size: rem(12px);
      font-style: normal;
      font-weight: 450;
      line-height: rem(14px);
      height: 24px;
      display: flex;
      align-items: center;
    }
  }
}
</style>
